import React from 'react';
import { Challenge } from '../lib/types';
import { Calendar } from 'lucide-react';
import { WinnerCard } from './WinnerCard';
import { PastChallengeCard } from './PastChallengeCard';

interface PastChallengesListProps {
  pastChallenges: Challenge[];
  votedSubmissions: string[];
  onVote: (submissionId: string) => void;
}

export function PastChallengesList({ pastChallenges, votedSubmissions, onVote }: PastChallengesListProps) {
  return (
    <div className="space-y-8">
      {pastChallenges.map((challenge) => (
        <PastChallengeCard
          key={challenge.id}
          challenge={challenge}
          isVoted={challenge.winner ? votedSubmissions.includes(challenge.winner.id) : false}
          onVote={onVote}
        />
      ))}
    </div>
  );
}
